var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmileySad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3364 50.1423C41.1415 50.1423 50.7114 40.5724 50.7114 28.7673C50.7114 16.9622 41.1415 7.39233 29.3364 7.39233C17.5313 7.39233 7.96143 16.9622 7.96143 28.7673C7.96143 40.5724 17.5313 50.1423 29.3364 50.1423Z",
    stroke: "#CD4B32",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5941 39.4547C37.6551 37.8306 36.3054 36.4821 34.6805 35.5445C33.0555 34.607 31.2125 34.1135 29.3365 34.1135C27.4605 34.1134 25.6175 34.607 23.9926 35.5444C22.3676 36.4819 21.0179 37.8304 20.0789 39.4545",
    stroke: "#CD4B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3208 26.9861C22.7964 26.9861 23.9927 25.7898 23.9927 24.3142C23.9927 22.8386 22.7964 21.6423 21.3208 21.6423C19.8452 21.6423 18.6489 22.8386 18.6489 24.3142C18.6489 25.7898 19.8452 26.9861 21.3208 26.9861Z",
    fill: "#CD4B32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3521 26.9861C38.8277 26.9861 40.0239 25.7898 40.0239 24.3142C40.0239 22.8386 38.8277 21.6423 37.3521 21.6423C35.8764 21.6423 34.6802 22.8386 34.6802 24.3142C34.6802 25.7898 35.8764 26.9861 37.3521 26.9861Z",
    fill: "#CD4B32"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileySad);
export default __webpack_public_path__ + "static/media/SmileySad.9ded16f0ed4c94881172a2d1c146caac.svg";
export { ForwardRef as ReactComponent };